import React from 'react';
import { Page, Text, Document, StyleSheet, Font } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    width: '100%'
  },
  title: {
    fontSize: 24,
    textAlign: 'left',
    fontFamily: 'Oswald'
  },
  author: {
    fontSize: 12,
    textAlign: 'left',
  },
  date: {
    fontSize: 12,
    textAlign: 'left',
    marginBottom: 20,
  },
  subtitle: {
    fontSize: 14,
    margin: 1,
    fontFamily: 'Oswald'
  },
  text: {
    margin: 1,
    fontSize: 13,
    textAlign: 'justify',
    fontFamily: 'Oswald',
    color: 'grey'
  },
  price: {
    marginTop: 20,
    fontSize: 20,
    textAlign: 'justify',
    letterSpacing: '1px',
    fontFamily: 'Oswald',
  },
  divider: {
    marginTop: 10,
    marginBottom: 10,
    height: '2px',
    background: '#4A4C51',
    border: '1px solid black'
  },
  left: {
    margin: 1,
    fontSize: 13,
    fontFamily: 'Oswald',
    color: 'grey',
  },
  overview: {
    margin: 1,
    fontSize: 13,
    // textAlign: 'right',
    fontFamily: 'Oswald',
  },
});

Font.register({
  family: 'Oswald',
  src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

interface IPreviewInvoice {
  planState: any;
  newPlan: string;
  cur_user: any;
}

const PreviewInvoice: React.FC<IPreviewInvoice> = ({ planState, newPlan, cur_user }) => {
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();

  return (
    <Document>
      <Page style={styles.body}>
        <Text style={styles.title}>BITE Data Corporation</Text>
        <Text style={styles.author}>Invoice Draft</Text>
        <Text style={styles.date}>{`${month}/${day}/${year}`}</Text>
        <Text style={styles.subtitle}>
          BITE Data Corporation
        </Text>
        <Text style={styles.text}>
          1037 Pleasant Street
        </Text>
        <Text style={styles.text}>
          Bridgewater, Massachusetts
        </Text>
        <Text style={styles.text}>
          02324
        </Text>
        <Text style={styles.text}>
          United States
        </Text>
        <Text style={styles.subtitle}>
          Bill to
        </Text>
        <Text style={styles.text}>
          {cur_user.selected_team.name}
        </Text>
        <Text style={styles.text}>
          {cur_user.basics.email}
        </Text>
        <Text style={styles.price}>
          ${(planState?.data?.selectedPrice?.amount * planState.data.quantity).toFixed(2)} USD /{planState?.data?.selectedPrice?.interval}
        </Text>
        <Text style={styles.divider}></Text>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          width: '100%'
        }}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignSelf: 'flex-end',
            width: '35%'
          }}
          >
            <Text style={styles.left}>
              Plan
            </Text>
            <Text style={styles.overview}>
              BITE {newPlan}
            </Text>
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignSelf: 'flex-end',
            width: '35%'
          }}
          >
            <Text style={styles.left}>
              Subtotal
            </Text>
            <Text style={styles.overview}>
              ${(planState?.data?.selectedPrice?.amount).toFixed(2)}
            </Text>
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignSelf: 'flex-end',
            width: '35%'
          }}
          >
            <Text style={styles.left}>
              Qty
            </Text>
            <Text style={styles.overview}>
              x{planState.data.quantity}
            </Text>
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignSelf: 'flex-end',
            width: '35%'
          }}
          >
            <Text style={styles.left}>
              Total
            </Text>
            <Text style={styles.overview}>
              ${(planState?.data?.selectedPrice?.amount * planState.data.quantity).toFixed(2)}
            </Text>
          </div>
        </div>
      </Page>
    </Document>
  );
};

export default PreviewInvoice;
